//  export const UserApi = "http://localhost:5000"
//  export const VendorApi = "http://localhost:5000/vendor"
//  export const AdminApi = "http://localhost:5000/admin"
//  export const socketApi = "http://localhost:5000"

// export const UserApi = 'https://snapsage.site'
// export const VendorApi = 'https://snapsage.site/vendor'
// export const AdminApi = 'https://snapsage.site/admin'
// export const socketApi ='https://snapsage.site'

export const UserApi = "https://snapsage-96ty.onrender.com"
 export const VendorApi = "https://snapsage-96ty.onrender.com/vendor"
 export const AdminApi = "https://snapsage-96ty.onrender.com/admin"
 export const socketApi = "https://snapsage-96ty.onrender.com"